import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { faqs } from "@/mocks/site";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
          <div className="lg:col-span-1">
            <SectionHeading
              eyebrow="常见问题"
              title="关于抖漫，你可能想先知道"
              desc="这里整理了新读者最常问的几个问题。如果还有疑问，也可以先到作品库实际体验一次筛选与搜索。"
              tone="accent"
            />
          </div>

          <div className="lg:col-span-2 flex flex-col gap-3">
            {faqs.map((faq, index) => {
              const open = openIndex === index;
              return (
                <div
                  key={faq.q}
                  className={`rounded-lg border bg-background-50 transition-colors ${
                    open ? "border-primary-300" : "border-background-200/70"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenIndex(open ? -1 : index)}
                    aria-expanded={open}
                    className="w-full flex items-center justify-between gap-4 text-left px-5 py-4"
                  >
                    <span className="flex items-center gap-3 min-w-0">
                      <span className="w-7 h-7 rounded-md bg-primary-100 text-primary-600 flex items-center justify-center text-sm shrink-0">
                        Q
                      </span>
                      <span className="text-foreground-950 text-sm md:text-base font-medium">{faq.q}</span>
                    </span>
                    <i
                      className={`text-foreground-400 text-xl shrink-0 transition-transform ${
                        open ? "ri-subtract-line" : "ri-add-line"
                      }`}
                      aria-hidden="true"
                    ></i>
                  </button>
                  <div className={open ? "block" : "hidden"}>
                    <p className="px-5 pb-5 md:pl-[60px] text-foreground-600 text-sm leading-relaxed">{faq.a}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}